import React from 'react';
import './privacy.css';

function PrivacyAndPolicy() {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
    

      <section className="privacy-section">
        <h2>Introduction</h2>
        <p>
          At Chavo Tours, we value your privacy. This Privacy Policy outlines the types of personal information we collect, how we use it, and how we ensure that it remains secure. By using our services, you agree to the collection and use of information in accordance with this policy.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Information We Collect</h2>
        <p>
          We collect various types of information in order to provide and improve our services. This includes:
        </p>
        <ul>
          <li><strong>Personal Information:</strong> When you book a ride with us, we collect your name, phone number, email address, and payment information.</li>
          <li><strong>Location Data:</strong> We collect location data to facilitate the booking and navigation of your ride.</li>
          <li><strong>Ride Information:</strong> We track details about your rides, including pick-up and drop-off locations, ride time, and payment transactions.</li>
          <li><strong>Device Information:</strong> Information such as your device's IP address, operating system, browser type, and device identifiers may be collected to improve the functionality of our app and website.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul>
          <li><strong>To Provide Services:</strong> We use your information to process your bookings, communicate with you, and deliver the ride service you requested.</li>
          <li><strong>To Improve Services:</strong> We analyze the data to improve our app, website, and overall customer experience.</li>
          <li><strong>For Customer Support:</strong> We may use your information to respond to your inquiries, resolve issues, and provide support.</li>
          <li><strong>For Marketing:</strong> We may use your email address to send promotional offers, updates, and newsletters (you can opt-out at any time).</li>
          <li><strong>Legal Compliance:</strong> We may use your information to comply with legal obligations, resolve disputes, or enforce our terms and conditions.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Data Security</h2>
        <p>
          We implement various security measures to protect your personal information, including encryption, firewalls, and secure payment gateways. However, no method of transmission over the internet is 100% secure, and we cannot guarantee the absolute security of your data.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Sharing Your Information</h2>
        <p>
          We do not sell or rent your personal information to third parties. However, we may share your data with the following parties:
        </p>
        <ul>
          <li><strong>Service Providers:</strong> We may share your data with third-party service providers who assist us in operating our website, providing our services, or conducting business activities.</li>
          <li><strong>Legal Authorities:</strong> If required by law, we may disclose your information to comply with legal processes or enforce our terms of service.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar technologies to enhance your experience on our website and mobile app. These technologies help us track your activity, preferences, and interactions with our services. You can manage cookie preferences through your browser settings.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal data. You can request to view the information we have about you, and we will comply in accordance with applicable law.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Effective Date." We encourage you to review this policy periodically to stay informed about how we are protecting your information.
        </p>
      </section>
    </div>
  );
}

export default PrivacyAndPolicy;


